import { render, staticRenderFns } from "./adiarAulaAlunoDialog.vue?vue&type=template&id=1f5b5c6c&scoped=true"
import script from "./adiarAulaAlunoDialog.vue?vue&type=script&lang=js"
export * from "./adiarAulaAlunoDialog.vue?vue&type=script&lang=js"
import style0 from "./adiarAulaAlunoDialog.vue?vue&type=style&index=0&id=1f5b5c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b5c6c",
  null
  
)

export default component.exports